const TestimonialRepository = {
    Artist: {
        Ann: {
            excerpt: "Love the inventory feature so that I can keep track of all my art",
            image: "/assets/img/index/ann.png",
            link: "https://annwebersculpture.com",
            name: "Ann Weber",
            testimony: "The database has a lot of great features. Love the inventory feature so that I can keep track of all my art. Love the ability to create labels. Super easy to use."
        }
    },
    Gallery: {
        Alyss: {
            company: "Olson-Larsen Galleries",
            excerpt: "The administrative work we used to dread is now streamlined and enjoyable",
            image: "/assets/img/index/alyse_olsen_1x.webp",
            link: "https://olsonlarsen.com",
            location: "Des Moines, Iowa",
            name: "Alyss Vernon",
            testimony: "It's difficult to choose just a few favorite things about ArtCloud. The administrative work we used to dread is now streamlined and enjoyable because of ArtCloud's ease of use and myriad features that all function together. We are truly on cloud nine with ArtCloud."
        },

        Bruce: {
            company: "Schoolhouse Gallery",
            excerpt: "I can spend more time with clients and less time navigating an outdated database",
            image: "/assets/img/index/bruce_1x.webp",
            link: "https://galleryschoolhouse.com",
            location: "Provincetown, MA",
            name: "Bruce Ployer",
            testimony: "The ease of use and accessibility of information within the structure of the software is a game changer. From a sales perspective, I can spend more time with clients and less time navigating an outdated database and invoicing system. In addition the ability to create exhibitions within the software supports our marketing efforts and follow through with clients."
        },

        Daniel: {
            company: "Goldman Global Arts",
            excerpt: "The website for<br/>retail integration is fantastic and so<br/>easy to manage",
            image: "/assets/img/index/dan.webp",
            link: "https://goldmanproperties.com/gga",
            location: "Miami, FL",
            name: "Daniel Pezet",
            testimony: "The support team and sales teams are sensational. They are extremely responsive and professional. Anytime we need help with support, custom builds, reporting assistance, etc. Also - the system is user friendly and Gallery specific driven. Well done with development. In addition, the website for retail integration is fantastic and so easy to manage. Everything is linked from the Gallery on site side and requires very little development or customization."
        }
    }
}

export default TestimonialRepository;